import { debounce } from 'lodash-es';
import { waitForGlobal } from './script-helpers';

let promise: Promise<boolean> | undefined;

const refresh = debounce(async function refresh() {
  try {
    if (promise) {
      return;
    }
    promise = waitForGlobal('Yotpo');
    const exists = await promise;
    if (exists) {
      const api = new (window as any).Yotpo.API((window as any).yotpo);
      api.refreshWidgets();
    }
  } catch (error) {
    console.error(error); // eslint-disable-line no-console
  } finally {
    promise = undefined;
  }
}, 50);

export { refresh };
